import { ProvisioningEnum } from '../../types';
/**
 * TODO skip configuring name and provisioning for each squiggly and use
 * the `getSquigglyTemplates` method instead of accessing this object directly. Eg:
 *
 * @example
 * const mapping = {
 *   actionsAppointment: ['{{appointment.date}}', '{{appointment.longdate}}', ...],
 * };
 * const squigglyTemplates = getSquigglyTemplates('actionsAppointment', formatMessage);
 */
export const squigglyTemplates = {
  actionsAppointment: [
    {
      id: '{{appointment.date}}',
      name: 'Appointment Date',
    },
    {
      id: '{{appointment.longdate}}',
      name: 'Appointment Long Date',
    },
    {
      id: '{{appointment.duration}}',
      name: 'Appointment Duration',
    },
    {
      id: '{{appointment.status}}',
      name: 'Appointment Status',
    },
    {
      id: '{{cancelledAppointmentsListInDay}}',
      name: 'Cancelled Appointments List In Day',
    },
    {
      id: '{{facility.address}}',
      name: 'Facility Address',
    },
    {
      id: '{{facility.name}}',
      name: 'Facility Name',
    },
    {
      id: '{{facility.phone}}',
      name: 'Facility Phone',
    },
    {
      id: '{{facility.alternativePhone}}',
      name: 'Facility Alternative Phone',
    },
    {
      id: '{{patient.firstname}}',
      name: 'Patient Name',
    },
    {
      id: '{{provider.name}}',
      name: 'Provider Name',
    },
    {
      id: '{{system.url.appointmentChecklist}}',
      name: 'Appointment Checklist',
    },
    {
      id: '{{system.url.insuranceUrl}}',
      name: 'Insurance Upload Link',
      provisioning: ProvisioningEnum.Insurance,
    },
    {
      id: '{{system.url.reminder.confirm}}',
      name: 'Reminder Confirm Link',
    },
    {
      id: '{{system.url.selfScheduleUrl}}',
      name: 'Self Schedule Link',
    },
    {
      id: '{{system.url.chatUrl}}',
      name: 'Secure Chat Link',
      provisioning: ProvisioningEnum.Chat,
    },
    {
      id: '{{system.url.filesPage}}',
      name: 'Patient Files Link',
    },
    {
      id: '{{patientUsdBalance}}',
      name: 'Patient Balance in USD',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{patientBalance}}',
      name: 'Patient Balance',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{estimate.value}}',
      name: 'Estimate Value',
    },
  ],
  actionsRecall: [
    {
      id: '{{recall.date}}',
      name: 'Recall Date',
    },
    {
      id: '{{recall.monthandyear}}',
      name: 'Recall Month and Year',
    },
    {
      id: '{{appointmentType.name}}',
      name: 'Appointment Type',
    },
    {
      id: '{{facility.address}}',
      name: 'Facility Address',
    },
    {
      id: '{{facility.name}}',
      name: 'Facility Name',
    },
    {
      id: '{{facility.phone}}',
      name: 'Facility Phone',
    },
    {
      id: '{{facility.alternativePhone}}',
      name: 'Facility Alternative Phone',
    },
    {
      id: '{{patient.firstname}}',
      name: 'Patient Name',
    },
    {
      id: '{{patient.preferredName}}',
      name: 'Patient Preferred Name',
    },
    {
      id: '{{provider.name}}',
      name: 'Provider Name',
    },
    {
      id: '{{system.url.appointmentChecklist}}',
      name: 'Appointment Checklist',
    },
    {
      id: '{{system.url.insuranceUrl}}',
      name: 'Insurance Upload Link',
      provisioning: ProvisioningEnum.Insurance,
    },
    {
      id: '{{system.url.selfScheduleUrl}}',
      name: 'Self Schedule Link',
    },
    {
      id: '{{system.url.chatUrl}}',
      name: 'Secure Chat Link',
      provisioning: ProvisioningEnum.Chat,
    },
    {
      id: '{{system.url.filesPage}}',
      name: 'Patient Files Link',
    },
    {
      id: '{{patientUsdBalance}}',
      name: 'Patient Balance in USD',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{patientBalance}}',
      name: 'Patient Balance',
      provisioning: ProvisioningEnum.LumaPay,
    },
  ],
  actionsProcedure: [
    {
      id: '{{patient.firstname}}',
      name: 'Patient Name',
    },
    {
      id: '{{facility.alternativePhone}}',
      name: 'Facility Alternative Phone',
    },
    {
      id: '{{system.url.appointmentChecklist}}',
      name: 'Appointment Checklist',
    },
    {
      id: '{{system.url.insuranceUrl}}',
      name: 'Insurance Upload Link',
      provisioning: ProvisioningEnum.Insurance,
    },
    {
      id: '{{system.url.chatUrl}}',
      name: 'Secure Chat Link',
      provisioning: ProvisioningEnum.Chat,
    },
    {
      id: '{{system.url.filesPage}}',
      name: 'Patient Files Link',
    },
    {
      id: '{{patientUsdBalance}}',
      name: 'Patient Balance in USD',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{patientBalance}}',
      name: 'Patient Balance',
      provisioning: ProvisioningEnum.LumaPay,
    },
  ],
  actionsDiagnostic: [
    {
      id: '{{patient.firstname}}',
      name: 'Patient Name',
    },
    {
      id: '{{facility.alternativePhone}}',
      name: 'Facility Alternative Phone',
    },
    {
      id: '{{system.url.appointmentChecklist}}',
      name: 'Appointment Checklist',
    },
    {
      id: '{{system.url.insuranceUrl}}',
      name: 'Insurance Upload Link',
      provisioning: ProvisioningEnum.Insurance,
    },
    {
      id: '{{system.url.chatUrl}}',
      name: 'Secure Chat Link',
      provisioning: ProvisioningEnum.Chat,
    },
    {
      id: '{{system.url.filesPage}}',
      name: 'Patient Files Link',
    },
    {
      id: '{{patientUsdBalance}}',
      name: 'Patient Balance in USD',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{patientBalance}}',
      name: 'Patient Balance',
      provisioning: ProvisioningEnum.LumaPay,
    },
  ],
  broadcast: [
    {
      id: '{{appointmentType.name}}',
      name: 'Appointment Type',
    },
    {
      id: '{{appointment.date}}',
      name: 'Appointment Date',
    },
    {
      id: '{{appointment.monthandday}}',
      name: 'Appointment Month and Date',
    },
    {
      id: '{{appointment.longmonthanddate}}',
      name: 'Appointment Long Month and Date',
    },
    {
      id: '{{appointment.longdate}}',
      name: 'Appointment Long Date',
    },
    {
      id: '{{facility.address}}',
      name: 'Facility Address',
    },
    {
      id: '{{facility.name}}',
      name: 'Facility Name',
    },
    {
      id: '{{facility.alternativeName}}',
      name: 'Facility Alternative Name',
    },
    {
      id: '{{facility.phone}}',
      name: 'Facility Phone',
    },
    {
      id: '{{facility.specialInstructionsTemplates.LANGUAGE}}',
      name: 'Facility Special Instructions Templates',
    },
    {
      id: '{{user.name}}',
      name: 'User Name',
    },
    {
      id: '{{patient.firstname}}',
      name: 'Patient Name',
    },
    {
      id: '{{patient.preferredName}}',
      name: 'Patient Preferred Name',
    },
    {
      id: '{{provider.name}}',
      name: 'Provider Name',
    },
    {
      id: '{{provider.specialInstructionsTemplates.LANGUAGE}}',
      name: 'Provider Special Instructions Templates',
    },
    {
      id: '{{system.url.filesPage}}',
      name: 'Patient Files Link',
    },
    {
      id: '{{system.url.chatUrl}}',
      name: 'Secure Chat Link',
      provisioning: ProvisioningEnum.Chat,
    },
    {
      id: '{{system.url.appointmentChecklist}}',
      name: 'Appointment Checklist',
    },
    {
      id: '{{system.url.insuranceUrl}}',
      name: 'Insurance Upload Link',
      provisioning: ProvisioningEnum.Insurance,
    },
    {
      id: '{{system.url.selfScheduleUrl}}',
      name: 'Self Schedule Link',
    },
    {
      id: '{{appointmentType.specialInstructionsTemplates.LANGUAGE}}',
      name: 'Appointment Type Special Instructions Templates',
    },
    {
      id: '{{patientUsdBalance}}',
      name: 'Patient Balance in USD',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{patientBalance}}',
      name: 'Patient Balance',
      provisioning: ProvisioningEnum.LumaPay,
    },
  ],
  broadcastUpload: [
    /*
    {
      id: '{{appointmentType.name}}',
      name: 'Appointment Type',
    },
    {
      id: '{{appointment.date}}',
      name: 'Appointment Date',
    },
    {
      id: '{{facility.address}}',
      name: 'Facility Address',
    },
    {
      id: '{{facility.name}}',
      name: 'Facility Name',
    },
    {
      id: '{{facility.phone}}',
      name: 'Facility Phone',
    },
    {
      id: '{{provider.name}}',
      name: 'Provider Name',
    },
    */
    {
      id: '{{appointment.monthandday}}',
      name: 'Appointment Month and Date',
    },
    {
      id: '{{appointment.longmonthanddate}}',
      name: 'Appointment Long Month and Date',
    },
    {
      id: '{{patient.firstname}}',
      name: 'Patient First Name',
    },
    {
      id: '{{user.name}}',
      name: 'User Name',
    },
    {
      id: '{{system.url.chatUrl}}',
      name: 'Secure Chat Link',
      provisioning: ProvisioningEnum.Chat,
    },
    {
      id: '{{system.url.appointmentChecklist}}',
      name: 'Appointment Checklist',
    },
    {
      id: '{{system.url.insuranceUrl}}',
      name: 'Insurance Upload Link',
      provisioning: ProvisioningEnum.Insurance,
    },
    {
      id: '{{system.url.selfScheduleUrl}}',
      name: 'Self Schedule Link',
    },
    {
      id: '{{patientUsdBalance}}',
      name: 'Patient Balance in USD',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{patientBalance}}',
      name: 'Patient Balance',
      provisioning: ProvisioningEnum.LumaPay,
    },
  ],
  hub: [
    {
      id: '{{me.name}}',
      name: 'Your Name',
    },
    {
      id: '{{patient.name}}',
      name: 'Patient Name',
    },
    {
      id: '{{patient.firstname}}',
      name: 'Patient First Name',
    },
    {
      id: '{{patient.lastname}}',
      name: 'Patient Last Name',
    },
    {
      id: '{{patient.nextAppointment.date}}',
      name: 'Patient Next Appointment Date',
    },
    {
      id: '{{patient.nextAppointment.facility.name}}',
      name: 'Patient Next Appointment Facility Name',
    },
    {
      id: '{{patient.nextAppointment.facility.alternativeName}}',
      name: 'Patient Next Appointment Facility Alternative Name',
    },
    {
      id: '{{patient.nextAppointment.provider.name}}',
      name: 'Patient Next Appointment Provider Name',
    },
    {
      id: '{{system.url.filesPage}}',
      name: 'Patient Files Link',
    },
    {
      id: '{{system.url.selfScheduleUrl}}',
      name: 'Self Schedule Link',
    },
    {
      id: '{{system.url.appointmentChecklist}}',
      name: 'Appointment Checklist',
    },
    {
      id: '{{system.url.insuranceUrl}}',
      name: 'Insurance Upload Link',
      provisioning: ProvisioningEnum.Insurance,
    },
    {
      id: '{{system.url.chatUrl}}',
      name: 'Secure Chat Link',
      provisioning: ProvisioningEnum.Chat,
    },
    {
      id: '{{user.firstname}}',
      name: 'User First Name',
    },
    {
      id: '{{user.lastname}}',
      name: 'User Last Name',
    },
    {
      id: '{{user.name}}',
      name: 'User Name',
    },
    {
      id: '{{patientUsdBalance}}',
      name: 'Patient Balance in USD',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{patientBalance}}',
      name: 'Patient Balance',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{system.url.adhocTelehealth}}',
      name: 'Start Zoom Meeting',
    },
  ],
  systemTemplatesWaitingRoom: [
    {
      id: '{{appointment.date}}',
      name: 'Appointment Date',
    },
    {
      id: '{{appointment.duration}}',
      name: 'Appointment Duration',
    },
    {
      id: '{{appointment.status}}',
      name: 'Appointment Status',
    },
    {
      id: '{{facility.name}}',
      name: 'Facility Name',
    },
    {
      id: '{{facility.address}}',
      name: 'Facility Address',
    },
    {
      id: '{{facility.phone}}',
      name: 'Facility Phone',
    },
    {
      id: '{{facility.alternativePhone}}',
      name: 'Facility Alternative Phone',
    },
    {
      id: '{{system.url.appointmentChecklist}}',
      name: 'Appointment Checklist',
    },
    {
      id: '{{system.url.insuranceUrl}}',
      name: 'Insurance Upload Link',
      provisioning: ProvisioningEnum.Insurance,
    },
    {
      id: '{{patient.firstname}}',
      name: 'Patient Name',
    },
    {
      id: '{{patientUsdBalance}}',
      name: 'Patient Balance in USD',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{patientBalance}}',
      name: 'Patient Balance',
      provisioning: ProvisioningEnum.LumaPay,
    },
  ],
  systemTemplates: [
    {
      id: '{{appointment.date}}',
      name: 'Appointment Date',
    },
    {
      id: '{{futureAppointment.date}}',
      name: 'Future Appointment Date',
    },
    {
      id: '{{appointment.longdate}}',
      name: 'Appointment Long Date',
    },
    {
      id: '{{futureAppointment.longdate}}',
      name: 'Future Appointment Long Date',
    },
    {
      id: '{{availability.date}}',
      name: 'Availability Date',
    },
    {
      id: '{{appointment.duration}}',
      name: 'Appointment Duration',
    },
    {
      id: '{{appointment.status}}',
      name: 'Appointment Status',
    },
    {
      id: '{{appointmentType.specialInstructionsTemplates.LANGUAGE}}',
      name: 'Appointment Type Special Instructions Templates',
    },
    {
      id: '{{doNotContactMessage.text}}',
      name: 'Do Not Contact Text',
    },
    {
      id: '{{facility.address}}',
      name: 'Facility Address',
    },
    {
      id: '{{facility.name}}',
      name: 'Facility Name',
    },
    {
      id: '{{facility.alternativeName}}',
      name: 'Facility Alternative Name',
    },
    {
      id: '{{facility.phone}}',
      name: 'Facility Phone',
    },
    {
      id: '{{facility.phonetic}}',
      name: 'Facility Phonetic Name',
    },
    {
      id: '{{facility.specialInstructionsTemplates.LANGUAGE}}',
      name: 'Facility Special Instructions Templates',
    },
    {
      id: '{{message.text}}',
      name: 'Message',
    },
    {
      id: '{{offer._id}}',
      name: 'Offer Id',
    },
    {
      id: '{{system.url.patientFormUrl}}',
      name: 'Patient Intake Form',
    },
    {
      id: '{{patient.name}}',
      name: 'Patient Name',
    },
    {
      id: '{{patient.firstname}}',
      name: 'Patient First Name',
    },
    {
      id: '{{patient.lastname}}',
      name: 'Patient Last Name',
    },
    {
      id: '{{patient.lastname | initial}}',
      name: 'Patient Last Name',
    },
    {
      id: '{{patient._id}}',
      name: 'Patient Id',
    },
    {
      id: '{{provider.name}}',
      name: 'Provider Name',
    },
    {
      id: '{{renderingProvider.name}}',
      name: 'Rendering Provider Name',
    },
    {
      id: '{{provider.specialInstructionsTemplates.LANGUAGE}}',
      name: 'Provider Special Instructions Templates',
    },
    {
      id: '{{referral.calledAtDate}}',
      name: 'Referral Call Date',
    },
    {
      id: '{{referral.referringProvider}}',
      name: 'Referral Doctor Name',
    },
    {
      id: '{{user._id}}',
      name: 'User Id',
    },
    {
      id: '{{user.name}}',
      name: 'User Name',
    },
    {
      id: '{{user.email}}',
      name: 'User Email',
    },
    {
      id: '{{user.settings.cancellation.expiration}}',
      name: 'Cancellation Expiration Time',
    },
    {
      id: '{{waitlist._id}}',
      name: 'Waitlist Id',
    },
    {
      id: '{{groupInvite.group.name}}',
      name: 'Invite Group Name',
    },
    {
      id: '{{system.url.filesPage}}',
      name: 'Patient Files Link',
    },
    {
      id: '{{system.url.groupInvite.invite}}',
      name: 'Group Invitation Link',
    },
    {
      id: '{{system.contact.value}}',
      name: 'System Contact value',
    },
    {
      id: '{{system.referral.inboundNumber}}',
      name: 'Referral Inbound Number',
    },
    {
      id: '{{system.url.offer.value}}',
      name: 'Availability Offer Link',
    },
    {
      id: '{{system.url.appointmentChecklist}}',
      name: 'Appointment Checklist',
    },
    {
      id: '{{system.url.insuranceUrl}}',
      name: 'Insurance Upload Link',
      provisioning: ProvisioningEnum.Insurance,
    },
    {
      id: '{{system.url.chatUrl}}',
      name: 'Chat Link',
      provisioning: ProvisioningEnum.Chat,
    },
    {
      id: '{{system.url.appointment.decline}}',
      name: 'Appointment Schedule Cancellation Link',
    },
    {
      id: '{{system.url.appointment.confirm}}',
      name: 'Appointment Schedule Confirmation Link',
    },
    {
      id: '{{system.url.selfScheduleUrl}}',
      name: 'Self Schedule Link',
    },
    {
      id: '{{system.url.reminder.cancel}}',
      name: 'Reminder Cancel Link',
    },
    {
      id: '{{system.url.reminder.confirm}}',
      name: 'Reminder Confirm Link',
    },
    {
      id: '{{system.url.referral.cancel}}',
      name: 'Referral Cancellation link',
    },
    {
      id: '{{system.url.referral.schedule}}',
      name: 'Referral Schedule Link',
    },
    {
      id: '{{system.url.referralUrl}}',
      name: 'Referral Page Link',
    },
    {
      id: '{{system.url.scoreFeedbackUrl}}',
      name: 'Score Feedback Link',
    },
    {
      id: '{{system.url.positiveFeedbackUrl}}',
      name: 'Positive Feedback Link',
    },
    {
      id: '{{system.url.negativeFeedbackUrl}}',
      name: 'Negative Feedback Link',
    },
    {
      id: '{{system.url.feedbackPromoterType | capitalize}}',
      name: 'Feedback Promoter Link',
    },
    {
      id: '{{unsubscribeLink}}',
      name: 'Unsubscribe Link',
    },
    {
      id: '{{patientUsdBalance}}',
      name: 'Patient Balance in USD',
      provisioning: ProvisioningEnum.LumaPay,
    },
    {
      id: '{{patientBalance}}',
      name: 'Patient Balance',
      provisioning: ProvisioningEnum.LumaPay,
    },
  ],
};
